<template>
  <section class="container story04">
    <div class="wrap">
      <h2 class="story04--tit">Meet Our Brands</h2>
      <!-- <h3 class="story04--tit02">I AM THE LIGHT</h3> -->
      <p class="story04--descript">
        We are all Lifening
      </p>
      <!-- <h3 class="story04--tit02">YOU ARE THE LIGHT</h3> -->
      <p class="story04--descript">
        We may see Lifening
      </p>
      <!-- <h3 class="story04--tit02">WE ARE THE LIGHT</h3> -->
      <p class="story04--descript">
        We can start Lifening
      </p>
      <p class="story04--descript regul">
        현재를 가꾸는 당신에게, 라이프닝
      </p>
      <p class="story04--descript medi mb">
        Lifening, to you.
      </p>
      <div>
        <div class="row">
          <div class="col-sm-6 story04--con">
            <h3 class="story04--subtit">BI</h3>
            <!-- <img
              :src="image.imageLink"
              class="story04--img pointer"
              alt="incellderm"
              @click="downloadFile"
            /> -->
            <div class="story04--bi pointer" @click="downloadFile"></div>
          </div>

          <div class="col-sm-2 story04--con">
            <h3 class="story04--subtit">Color</h3>
            <div class="story04--colorwrap">
              <div class="story04--colorbar"></div>
              <div class="story04--colorcode">
                <dl class="story04--code">
                  <dt>HEX</dt>
                  <dd>#81D1DF</dd>
                  <dt>RGB</dt>
                  <dd>R129 G209 B223</dd>
                  <dt>CMYK</dt>
                  <dd>C46 M0 Y12 K0</dd>
                </dl>
              </div>
            </div>
          </div>

          <div class="col-sm-2 story04--con pt">
            <div class="story04--colorwrap">
              <div class="story04--colorbar bar02"></div>
              <div class="story04--colorcode">
                <dl class="story04--code">
                  <dt><span class="hide-pc">HEX</span></dt>
                  <dd>#ECF1CF</dd>
                  <dt><span class="hide-pc">RGB</span></dt>
                  <dd>R236 G241 B207</dd>
                  <dt><span class="hide-pc">CMYK</span></dt>
                  <dd>C8 M0 Y25 K0</dd>
                </dl>
              </div>
            </div>
          </div>

          <div class="col-sm-2 story04--con pt">
            <div class="story04--colorwrap">
              <div class="story04--colorbar bar03"></div>
              <div class="story04--colorcode">
                <dl class="story04--code">
                  <dt><span class="hide-pc">HEX</span></dt>
                  <dd>#C2DFE4</dd>
                  <dt><span class="hide-pc">RGB</span></dt>
                  <dd>R194 G223 B228</dd>
                  <dt><span class="hide-pc">CMYK</span></dt>
                  <dd>C26 M1 Y9 K0</dd>
                </dl>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import downloadApi from '@/apis/download';

export default {
  name: 'Section4',
  data() {
    return {
      image: {
        id: 'lifening',
        // imageLink: require('@/assets/images/brandstory/incellderm02.png'),
        downloadLink: `${process.env.VUE_APP_STATIC_URL}/HP-Rimankorea/CI/lifening_01.png` /* 병헌 : 변경해야 함 */
      },
    };
  },
  methods: {
    downloadFile() {
      downloadApi.downloadFile(this.image.downloadLink, this.image.downloadLink.substr(this.image.downloadLink.lastIndexOf('/') + 1));
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
